export const canEditPaymentRequest = (item) => {
  if (item.status === 'pending') {
    return true;
  }
  return false;
};
